import { useState } from "react";
import { useForm } from "@mantine/form";
import {
  Container,
  Text,
  Paper,
  Group,
  Button,
  Stack,
  PasswordInput,
} from "@mantine/core";
import { setPassword } from "./authApi";
import { useTranslation } from "react-i18next";
import LangSelector from "./LangSelector";
import { notifications } from "@mantine/notifications";
import { useLocation } from "wouter";

export default function SetPassword() {
  const [isFetching, setIsFetching] = useState(false);
  const { t } = useTranslation("Auth");
  const [, setLocation] = useLocation();

  const form = useForm({
    initialValues: {
      newPassword: "",
    },
    validate: {
      newPassword: (val) => (/^.{8}/.test(val) ? null : t("invalid_password")),
    },
  });

  return (
    <Container size="sm" mt="xl">
      <Paper radius="md" p="xl" withBorder>
        <Group align="flex-start" justify="space-between">
          <Text size="lg" mb="xl" fw={500}>
            {t("set_password", "Set password")}
          </Text>
          <LangSelector />
        </Group>

        <form
          onSubmit={form.onSubmit((values) => {
            setIsFetching(true);
            setPassword({ newPassword: values.newPassword })
              .then(() => {
                notifications.show({ title: t("password_set", "Password set!") });
                setLocation("/profile");
              })
              .catch((err) => {
                notifications.show({
                  title: "An error occurred!",
                  message: "" + err,
                });
              })
              .finally(() => {
                setIsFetching(false);
              });
          })}
        >
          <Stack>
            <PasswordInput
              required
              label={t("new_password")}
              disabled={isFetching}
              {...form.getInputProps("newPassword")}
              radius="md"
            />

            <Button loading={isFetching} type="submit" radius="xl">
              {t("set_password", "Set password")}
            </Button>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
}
